import { useEffect, useState } from 'react';
import { SITE } from '../data/site';

// Evergreen offer timer (same idea as the onboarding reward pages): 25 minutes per visitor,
// remembered across reloads, restarted once it runs out.
const LIMIT = 25 * 60 * 1000;
let memStart = 0; // fallback when localStorage throws

function readStart(now) {
    let start = memStart;
    try { start = Number(localStorage.getItem(SITE.storage.offer)) || memStart; } catch {}
    const age = now - start;
    if (!start || age < 0 || age >= LIMIT) {
        start = now;
        try { localStorage.setItem(SITE.storage.offer, String(now)); } catch {}
    }
    memStart = start;
    return start;
}

const msLeft = () => { const now = Date.now(); return LIMIT - (now - readStart(now)); };

// Re-renders its caller every second: call it from a leaf component only.
export function useCountdown() {
    const [ms, setMs] = useState(msLeft);

    useEffect(() => {
        let t;
        const tick = () => {
            const left = msLeft();
            setMs(left);
            t = setTimeout(tick, (left % 1000) || 1000); // land on second boundaries, no drift
        };
        tick();
        return () => clearTimeout(t);
    }, []);

    const s = Math.floor(ms / 1000);
    return { mm: String(Math.floor(s / 60)).padStart(2, '0'), ss: String(s % 60).padStart(2, '0') };
}
